import * as types from "../mutation-types";

const taxPayTypes = [
    { labelId: "taxes_out_of_pocket", value: 0 },
    { labelId: "taxes_sale_of_shares", value: 1 }
];

function initialState() {
    return {
        firstSetIncludeTaxes: true, // firstly set includeTaxes on, need to set settings with preferenceSettings
        taxType: 0, //TODO: 0 - US 1 - CA
        includeTax: null, // init by preferenceSetting
        taxFilingStatus: 1, // filing status
        taxableIncome: null, // taxable income, init by preferenceSetting
        taxPayType: null, // payOption， init by preferenceSetting
        federalTaxRate: null, // federal income, init by  calculation
        stateTaxRate: 0, // state
        capgainTaxRate: null, // capital gain, init by  calculation
        filingStatuses: [],
        taxRateInfo: []
    };
}

const state = {
    ...initialState()
};

const getters = {
    taxPayTypes() {
        return taxPayTypes;
    },
    taxSetting(state, getters, rootState) {
        if (state.includeTax) {
            return {
                includeTax: state.includeTax,
                taxType: state.taxType,
                taxPayType: state.taxPayType,
                taxFilingStatus: state.taxFilingStatus,
                taxableIncome: state.taxableIncome,
                federalTaxRate: state.federalTaxRate,
                capgainTaxRate: state.capgainTaxRate,
                stateTaxRate: state.stateTaxRate
            };
        }
        return undefined;
    },
    getPreferenceTaxSetting(state, getters, rootState) {
        return rootState.settings.preferences.taxSetting;
    },
    federalTaxRateInfo(state) {
        return state.taxRateInfo.filter(tr => {
            return tr.taxTypeId === 1; // Federal Income Tax Rate
        });
    },
    capgainTaxRateInfo(state) {
        return state.taxRateInfo.filter(tr => {
            return tr.taxTypeId === 2; // Capital Gain Tax Rate
        });
    },
    calculateFederalTaxRate(state) {
        let federalTaxRate = 0;
        getters
            .federalTaxRateInfo(state)
            .filter(tr => {
                return tr.filingStatusId === state.taxFilingStatus;
            })
            .forEach(tr => {
                if (tr.floorValue < state.taxableIncome && (!tr.capValue || (tr.capValue && state.taxableIncome <= tr.capValue))) {
                    if (federalTaxRate < tr.taxRate) {
                        federalTaxRate = tr.taxRate;
                    }
                }
            });
        return federalTaxRate;
    },
    calculateCapgainTaxRate(state) {
        let capgainTaxRate = 0;
        getters
            .capgainTaxRateInfo(state)
            .filter(tr => {
                return tr.filingStatusId === state.taxFilingStatus;
            })
            .forEach(tr => {
                if (tr.floorValue < state.taxableIncome && (!tr.capValue || (tr.capValue && state.taxableIncome <= tr.capValue))) {
                    if (capgainTaxRate < tr.taxRate) {
                        capgainTaxRate = tr.taxRate;
                    }
                }
            });
        return capgainTaxRate;
    }
};

const actions = {
    getTaxrate({ state, commit }, { fetch, countryId = "USA" }) {
        if (state.taxRateInfo.length !== 0) {
            return false;
        }
        return fetch({
            url: `/api/v1/Application/${countryId}/Taxrate`,
            method: "GET"
        }).then(data => {
            commit(types.SET_TAXRATE_INFO, data.taxRateInfo);
            commit(types.SET_FILING_STATUSES, data.taxRateFilingStatus);
            if (state.federalTaxRate === null && state.capgainTaxRate === null) {
                commit(types.CALCULATE);
            }
        });
    }
};

const mutations = {
    [types.UPDATE_TAX_SETTING](state, data) {
        if (data) {
            state.includeTax = data.includeTax;
            state.taxableIncome = data.taxableIncome;
            state.taxPayType = data.taxPayType;
            if (typeof data.taxType !== "undefined") {
                state.taxType = data.taxType;
            }
            if (typeof data.taxFilingStatus !== "undefined") {
                state.taxFilingStatus = data.taxFilingStatus;
            }
            if (typeof data.stateTaxRate !== "undefined") {
                state.stateTaxRate = data.stateTaxRate;
            }
            if (typeof data.federalTaxRate !== "undefined") {
                state.federalTaxRate = data.federalTaxRate;
            }
            if (typeof data.capgainTaxRate !== "undefined") {
                state.capgainTaxRate = data.capgainTaxRate;
            }
        } else {
            state.includeTax = false;
        }
    },
    [types.CALCULATE](state) {
        state.federalTaxRate = getters.calculateFederalTaxRate(state, getters);
        state.capgainTaxRate = getters.calculateCapgainTaxRate(state, getters);
    },
    [types.SET_TAXRATE_INFO](state, data) {
        state.taxRateInfo = data;
    },
    [types.SET_FILING_STATUSES](state, data) {
        state.filingStatuses = data;
    },
    [types.SET_INCLUDE_TAX](state, data) {
        state.includeTax = data;
        if (state.includeTax === true && state.firstSetIncludeTaxes === true) {
            state.federalTaxRate = getters.calculateFederalTaxRate(state, getters);
            state.capgainTaxRate = getters.calculateCapgainTaxRate(state, getters);
        }
        state.firstSetIncludeTaxes = false;
    },
    [types.SET_TAXFILINGSTATUS](state, data) {
        state.taxFilingStatus = data;
        state.federalTaxRate = getters.calculateFederalTaxRate(state, getters);
        state.capgainTaxRate = getters.calculateCapgainTaxRate(state, getters);
    },
    [types.SET_TAXABLEINCOME](state, data) {
        state.taxableIncome = data;
        state.federalTaxRate = getters.calculateFederalTaxRate(state, getters);
        state.capgainTaxRate = getters.calculateCapgainTaxRate(state, getters);
    },
    [types.SET_TAXPAYTYPE](state, data) {
        state.taxPayType = data;
    },
    [types.SET_FEDERALTAXRATE](state, data) {
        state.federalTaxRate = data;
    },
    [types.SET_STATETAXRATE](state, data) {
        state.stateTaxRate = data;
    },
    [types.SET_CAPGAINTAXRATE](state, data) {
        state.capgainTaxRate = data;
    },
    [types.RESET](state) {
        const initialData = initialState();
        Object.keys(initialData).forEach(key => {
            state[key] = initialData[key];
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
